var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"redirect-view"},[_c('ui-button',{on:{"click":_vm.redirect}},[_vm._v("Return To App")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }